module.exports = __webpack_public_path__ + "static/media/SZ45003W_03.c35746ef.png";